// extracted by mini-css-extract-plugin
export var borderRadius = "_g7-4";
export var large = "_g7-3";
export var logoContainer = "_g7-0";
export var nameLogo = "_g7-2";
export var small = "_g7-1";